import { memo, forwardRef } from 'react';
import { useTheme, Button, Text, Markdown } from '@Sage/hoi-poi-ui';

const SyncStatusBadgePopover = forwardRef(({ title, rows, cta }, ref) => {
    const theme = useTheme();
    return (
        <div ref={ref} className="fm-ssbadge__popover-inner">
            {title && (
                <Text className="fm-ssbadge__popover-header" type="subtitle" medium>
                    {title}
                </Text>
            )}
            {rows?.length &&
                rows.map(({ label, value }, index) => (
                    <div className="fm-ssbadge__popover-row" key={`${label}-${index}`}>
                        <Text
                            className="fm-ssbadge__popover-row-label"
                            color={theme.colors.utility.textSecondary}
                        >
                            {label}
                        </Text>
                        <Markdown
                            className="fm-ssbadge__popover-row-value"
                            content={value}
                            overrides={{ a: { target: '_blank' } }}
                        />
                    </div>
                ))}
            {cta?.length && (
                <div className="fm-ssbadge__popover-footer">
                    {cta.map(({ text, onClick, type = 'primary' }, index) => (
                        <Button key={`${text}-${index}`} size="small" type={type} onClick={onClick}>
                            {text}
                        </Button>
                    ))}
                </div>
            )}
        </div>
    );
});

export default memo(SyncStatusBadgePopover);
